import { PersistentStore } from "bi-lib";

export const tokenStore = new PersistentStore<string | undefined>("token", undefined);
